import {
  Button,
  Feedback,
  ListGroup,
  Modal,
  Overlay,
} from '@cubeyou-team/hx-react-components';
import React, { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useRepositoryItemContext } from 'src/components/RepositoryItem/providers/RepositoryItemProvider';
import translations from 'src/lang';
import { requestRepository } from 'src/actions/RepositoryActions';
import { QUERY_TYPE_IDS } from '@discover-frontend/constants';
import { useDeleteCampaign } from '../AudienceActivationModal/api/hooks/useDeleteCampaign';

const translation = translations['en-US'];

interface DeleteCampaignModalProps {
  campaignId: string;
}

export const DeleteCampaignModal: FC<DeleteCampaignModalProps> = ({
  campaignId,
}) => {
  const {
    showDeleteCampaignModal,
    onCloseDeleteCampaignModal,
  } = useRepositoryItemContext();
  const dispatch = useDispatch();
  const [feedbackStatus, setFeedbackStatus] = useState<string>('warning');
  const [feedbackMessage, setFeedbackMessage] = useState<string>(
    translation.MODALS.DELETE_CAMPAIGN.MODAL_CONTENT
  );

  const onSuccess = useCallback(() => {
    onCloseDeleteCampaignModal();
    dispatch(requestRepository(QUERY_TYPE_IDS.CAMPAIGN));
  }, [dispatch, onCloseDeleteCampaignModal]);

  const onError = useCallback(() => {
    setFeedbackStatus('error');
    setFeedbackMessage(translation.MODALS.DELETE_CAMPAIGN.ERROR_MESSAGE);
  }, [setFeedbackStatus, setFeedbackMessage]);

  const {
    isLoading = false,
    isError,
    mutate: deleteCampaign,
  } = useDeleteCampaign({
    onSuccess,
    onError,
  });

  const handleDeleteCampaign = useCallback(() => deleteCampaign(campaignId), [
    campaignId,
    deleteCampaign,
  ]);

  return (
    <Overlay isOpen={showDeleteCampaignModal}>
      <Modal
        title={translation.MODALS.DELETE_CAMPAIGN.MODAL_TITLE}
        footer={
          <ListGroup
            direction="row"
            items={[
              <Button
                type="submit"
                size="small"
                loading={isLoading}
                disabled={isError}
                onClick={handleDeleteCampaign}
              >
                {translation.MODALS.DELETE_CAMPAIGN.BUTTON_DELETE}
              </Button>,
              <Button
                size="small"
                variant={'outlined'}
                disabled={isLoading}
                onClick={onCloseDeleteCampaignModal}
              >
                {translation.MODALS.DELETE_CAMPAIGN.BUTTON_CANCEL}
              </Button>,
            ]}
          />
        }
        closable
        handleClose={onCloseDeleteCampaignModal}
      >
        <Feedback message={feedbackMessage} status={feedbackStatus} />
      </Modal>
    </Overlay>
  );
};
